import { FunctionComponent } from 'react';
import classNames from 'classnames';
import styles from '../styles.module.scss';
import { ArrowLeftIcon } from '../../../../../../Icons';
import { SlotPicker, SlotPickerProps } from '../../../../../AvailableDayPicker/SlotPicker';

export const SlotPickerWithPlaceholder: FunctionComponent<
    SlotPickerProps & { selectedDay: Date | undefined }
> = ({ slots, onClick, value, selectedDay, timezone, locale }) => {
    if (!selectedDay) {
        return (
            <div
                className={classNames(
                    styles.slotsPlaceholder,
                    styles.animate__animated,
                    styles.animate__infinite,
                    styles.animate__pulse
                )}
            >
                <ArrowLeftIcon className={styles.placeholderArrow} />
                <span>Select a Date</span>
            </div>
        );
    }

    return (
        <SlotPicker
            slots={slots}
            onClick={onClick}
            value={value}
            timezone={timezone}
            locale={locale}
        />
    );
};
